import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

class EventData extends Component {
  render() {
    const { handleSubmit, initialValues } = this.props;
    return (
      <div>
	{/* eventName : string, wymagane
	startDate : string, wymagane
	endDate : string, wymagane
	place : string, wymagane
	parity : bool, wymagane
    departments : [] NIE DAWAĆ */}
        <form
          onSubmit={handleSubmit}
          className="eventform-wip"
        >
          <p>
            <label>Nazwa</label>
            <Field
              name="eventName"
              component="input"
            />
          </p>
          <p>
            <label>Start</label>
            <Field
              name="startDate"
              component="input"
            />
          </p>
          <p>
            <label>Zakonczenie</label>
            <Field
              name="endDate"
              component="input"
            />
          </p>
          <p>
            <label>Miejsce</label>
            <Field
              name="place"
              component="input"
            />
          </p>
          <p>
            <label>Parytet?</label>
            <Field
              name="parity"
              pattern="true||false"
              title="true albo false"
              component="input"
            />
          </p>
          {
            initialValues 
            ? initialValues.departments !== undefined &&
            initialValues.departments.map( (e, i) => 
            <div key={i}>
              <label>Wydział:</label>
              <Field
                name={`departments[${i}].departmentName`}
                component="input"
              />
              <label>Liczba miejsc:</label>
              <Field
                name={`departments[${i}].maxStudentsCount`}
                component="input"
              />
              <p>Zajęte miejsca: {e.actualStudentsCount}</p>
            </div>
            )
            :
            <div>
              <label>Wydział:</label>
              <Field
                name={`departments[0].departmentName`}
                component="input"
              />
              <label>Liczba miejsc:</label>
              <Field
                name={`departments[0].maxStudentsCount`}
                component="input"
              />
            </div>
          }
          <button>Zaktualizuj</button>
        </form>

      </div>
    )
  }
};

export default reduxForm({
  form: 'event'
})(EventData);


// WEBPACK FOOTER //
// ./src/modules/Admin/components/EventData.js